<template>
    <div class="measure">
        <titles name="测量信息"></titles>
        <ul class="content">
            <li>
                <div class="titleDiv">
                    测量员： 
                    <span class="titleSpan">{{item.surveyorName}}</span>
                </div>
                <div class="titleDiv">
                    测量时间：
                    <span class="titleSpan">{{item.surveyorTime}}</span> 
                </div>
                <div class="titleDiv">
                    测量地址： 
                    <span class="titleSpan">{{item.surveyorAddress}}</span> 
                </div>
                <div class="titleDiv">
                    备注： 
                    <span class="titleSpan">{{item.surveyorRemarks}}</span> 
                </div>
                <!-- <div class="flex-row titleDiv">
                    <p class="m-r-51">附件汇报</p>
                    <div class="titleSpan">
                        <img class="m-r-20" :src="lion" alt="">
                        <img :src="lion" alt="">
                    </div>
                </div> -->
            </li>
        </ul>
    </div>
</template>
<script>
import titles from '@/components/titiles.vue';
import lion from '@/assets/img/lion.jpg'
export default {
    components:{
        titles,
    },
    props: {
        item: {
        type: Object,
        default: {}
        },
    },
    created(){
        console.log(this.item);
    },
    data(){
        return {
            lion
        }
    }
}
</script>
<style lang="scss" scoped>
.measure{
    background: $ffff;
    padding-bottom: 2px;
    margin-bottom: 20px;
    .content{
        margin:20px 55px 0 55px;
        background: $ffff;
        font-size:24px;
        color:$color-51;
        li{
            div{
                margin-bottom: 27px;
            }
            img{
                width:110px;
                height:110px;
            }
        }
        span{
            color: $color-153;
        }
    }
}
.titleDiv{
    // position: relative;
    .titleSpan{
        // position: absolute;
        // left: 150px;
        line-height: 34px;
    }
}
</style>


